import { StatusId } from "~/common/constants";
import type { TPatient } from "~/types/patient";

/**
 * Pure status-filter helpers shared by the legacy patients list (`patients_list_new.tsx`, a
 * multi-select) and the redesign-v1 patients page (`components/redesign-v1/patients`, six status
 * tabs). Extracted to a side-effect-free module so the redesign's lazy chunk can reuse the EXACT
 * expansion without pulling the legacy component's `react-select` / `makeAnimated()` module init.
 */
export type TSelectOption = {
  value: StatusId;
  label: TPatient["status"];
};

/**
 * Build the `status` query param from selected status options. Two statuses are UI-collapsed and must
 * expand to their hidden siblings so the backend filter matches what the doctor expects:
 *  - PRODUCTION_PRINTING also sends PLAN_3D_MODELS_BUILDING (the pre-print modeling state)
 *  - PRODUCTION_FABRICATING also sends PRODUCTION_ALLOCATING
 * Returns `false` for an empty selection (no `status` param → all patients).
 */
export function buildStatusFilter(options: TSelectOption[]): string | false {
  if (options.length === 0) {
    return false;
  }

  let status = "";
  for (const option of options) {
    if (option.value == StatusId.PRODUCTION_PRINTING) {
      status = `${status}${StatusId.PLAN_3D_MODELS_BUILDING},${StatusId.PRODUCTION_PRINTING},`;
    } else if (option.value == StatusId.PRODUCTION_FABRICATING) {
      status = `${status}${StatusId.PRODUCTION_ALLOCATING},${StatusId.PRODUCTION_FABRICATING},`;
    } else if (option.value == StatusId.POWER_CAP_PRODUCTION_PRINTING) {
      status = `${status}${StatusId.POWER_CAP_PLAN_3D_MODELS_BUILDING},${StatusId.POWER_CAP_PRODUCTION_PRINTING},`;
    } else if (option.value == StatusId.POWER_CAP_PRODUCTION_FABRICATING) {
      status = `${status}${StatusId.POWER_CAP_PRODUCTION_ALLOCATING},${StatusId.POWER_CAP_PRODUCTION_FABRICATING},`;
    } else {
      status = `${option.value},${status}`;
    }
  }

  return status.slice(0, status.length - 1);
}
